export const subdomainTypeEnum = {
    UNDEFINED: "UNDEFINED",
    EMAIL_VERIFIED: "EMAIL_VERIFIED",
    PASSWORD_RESET: "PASSWORD_RESET"
}